/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/rules-of-hooks */
import { ColumnDef } from '@tanstack/table-core';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { useState } from 'react';
// eslint-disable-next-line import/no-cycle
import { ToggleButton, ToggleButtonGroup, Button } from '@mui/material';
import ExpandableCell from 'src/components/collapsible-table/expandable-cell';
import _ from 'lodash';
import { handleToggleShowEditedPPGsClick } from '../store/table-slice';
import { handleToggleShowEditedPPGsClick as handleToggleShowEditedPPGsClick2 } from '../store/table-slice2';
import {
  TableComponent,
  Header
} from '../../../../pricing-simulator/types/generic-table.model';
import '../../../../pricing-simulator/components/list-price-simulation-table/list-price-simulation.scss';

export default function getColumnForDisplaySection(
  componentType: TableComponent,
  columnData: Header,
  columnMetadata: Header[],
  footerRows: any[] = []
) {
  // let copyofColumnMetaData = columnMetadata
  let tempVar = columnMetadata && columnMetadata.length && [...columnMetadata.filter((data) => (data.parent.field_format === 'TEXT'))].map((item) => {return item.children[0]})
  
  const expandableColumnsHeader = componentType === TableComponent.PRICING
      ? tempVar
      : columnMetadata && columnMetadata.length
      ? [
          columnData,
          ...columnMetadata.filter(
            data => data.parent.child_field && data.parent.field_format === 'TEXT'
          )
        ]
      : [];
  const isExpand = TableComponent.MULTIYEARESTIMATE != componentType;
  const subHeader: ColumnDef<{
    [key: string]: number | string | { [key: string]: string }[];
  }> = {
    accessorFn: (row, i) => {
      if (componentType === TableComponent.PPGLEVELIMPACT) {
        return row.ppg !== 'NAN'
          ? row.ppg
          : row.brand !== 'NAN'
          ? row.brand
          : row.cell;
      }
      if (componentType === TableComponent.MULTIYEARESTIMATE) {
        return row.cell;
      }
      return row.retailer === 'NAN' ? row.ppg : row.retailer;
    },
    id:
      columnData.parent.parent_field !== ''
        ? columnData.parent.parent_field
        : columnData.parent.order.toString(),
    meta: {
      className: columnData.parent.has_border
        ? 'last sticky-first-col'
        : 'sticky-first-col hide-border-col'
    },
    cell: ({ row, getValue }) => (
      <ExpandableCell
        row={row}
        value={getValue() as string}
        columnMetadata={isExpand ? expandableColumnsHeader : []}
        isExpand={isExpand}
      />
    ),
    header: ({ table }) => {
      const appDispatch = useAppDispatch();
      const [isAllExpanded, setIsAllExpanded] = useState(false);
      const { toggleLabelname } = useAppSelector((state) => state.table);
      const { isSKUEditedClick } = useAppSelector((state) => state.table);

      const { toggleLabelname: toggleLabelname2 } = useAppSelector(
        (state) => state.table2
      );
      const { isSKUEditedClick: isSKUEditedClick2 } = useAppSelector(
        (state) => state.table2
      );

      const onExpandAllClick = () => {
        setIsAllExpanded(!table.getIsAllRowsExpanded());
        table.toggleAllRowsExpanded(!table.getIsAllRowsExpanded());
      };
      if (TableComponent.MULTIYEARESTIMATE === componentType) {
        table.toggleAllRowsExpanded(true);
      }
      if (TableComponent.COGS === componentType) {
        return (
          <>
            {!_.isEmpty(toggleLabelname2) && (
              <ToggleButtonGroup
                size='small'
                onChange={() => {
                  appDispatch(handleToggleShowEditedPPGsClick2());
                }}
              >
                <ToggleButton
                  value={isSKUEditedClick2}
                  sx={{
                    width: '200px'
                  }}
                  className={`${
                    isSKUEditedClick2 ? 'active-toggle' : 'non-active-toggle'
                  }`}
                >
                  {isSKUEditedClick2
                    ? toggleLabelname2.replace('Edited', 'All')
                    : toggleLabelname2}
                </ToggleButton>
              </ToggleButtonGroup>
            )}
            {table.getCanSomeRowsExpand() && (
              <div style={{ marginTop: '5px' }}>
                {columnData.parent.should_show_expandall && (
                  <Button size='small' onClick={onExpandAllClick}>
                    <span>
                      {isAllExpanded
                        ? `Collapse All ${
                            toggleLabelname2
                              ? toggleLabelname2.split(' ').reverse()[0]
                              : ''
                          }`
                        : `Expand All ${
                            toggleLabelname2
                              ? toggleLabelname2.split(' ').reverse()[0]
                              : ''
                          }`}
                    </span>
                  </Button>
                )}
              </div>
            )}
          </>
        );
      }
      return (
        <>
          {!_.isEmpty(toggleLabelname) && (
            <ToggleButtonGroup
              size='small'
              onChange={() => {
                appDispatch(handleToggleShowEditedPPGsClick());
              }}
            >
              <ToggleButton
                value={isSKUEditedClick}
                sx={{
                  width: '200px'
                }}
                className={`${
                  isSKUEditedClick ? 'active-toggle' : 'non-active-toggle'
                }`}
              >
                {isSKUEditedClick
                  ? toggleLabelname.replace('Edited/Impacted', 'All')
                  : toggleLabelname}
              </ToggleButton>
            </ToggleButtonGroup>
          )}
          {table.getCanSomeRowsExpand() && (
            <div style={{ marginTop: '5px' }}>
              {columnData.parent.should_show_expandall && (
                <Button size='small' onClick={onExpandAllClick}>
                  <span>
                    {isAllExpanded
                      ? `Collapse All ${
                          toggleLabelname
                            ? toggleLabelname.split(' ').reverse()[0]
                            : ''
                        }`
                      : `Expand All ${
                          toggleLabelname
                            ? toggleLabelname.split(' ').reverse()[0]
                            : ''
                        }`}
                  </span>
                </Button>
              )}
            </div>
          )}
        </>
      );
    },
    footer: (props) => {
      const data = footerRows?.map((footerRow) => footerRow.parent.data.label);
      if (
        TableComponent.PPGLEVELIMPACT == componentType ||
        TableComponent.MULTIYEARESTIMATE == componentType
      ) {
        return (
          <>
            {data.map((val) => (
              <div style={{ height: '30px' }} key={val}>
                <span>{val}</span>
              </div>
            ))}
          </>
        );
      }
      // return <span>Total Manufacturing Impact2</span>;
    }
  };
  return subHeader;
}
